/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reportpb/taxwithholdingdiv.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reportpb = require('./taxwithholdingdiv_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.TaxWithholdingDivServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.TaxWithholdingDivServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListTaxWithholdingDivRequest,
 *   !proto.reportpb.ListTaxWithholdingDivResponse>}
 */
const methodDescriptor_TaxWithholdingDivService_ListTaxWithholdingDiv = new grpc.web.MethodDescriptor(
  '/reportpb.TaxWithholdingDivService/ListTaxWithholdingDiv',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListTaxWithholdingDivRequest,
  proto.reportpb.ListTaxWithholdingDivResponse,
  /**
   * @param {!proto.reportpb.ListTaxWithholdingDivRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListTaxWithholdingDivResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListTaxWithholdingDivRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListTaxWithholdingDivResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListTaxWithholdingDivResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.TaxWithholdingDivServiceClient.prototype.listTaxWithholdingDiv =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.TaxWithholdingDivService/ListTaxWithholdingDiv',
      request,
      metadata || {},
      methodDescriptor_TaxWithholdingDivService_ListTaxWithholdingDiv,
      callback);
};


/**
 * @param {!proto.reportpb.ListTaxWithholdingDivRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListTaxWithholdingDivResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.TaxWithholdingDivServicePromiseClient.prototype.listTaxWithholdingDiv =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.TaxWithholdingDivService/ListTaxWithholdingDiv',
      request,
      metadata || {},
      methodDescriptor_TaxWithholdingDivService_ListTaxWithholdingDiv);
};


module.exports = proto.reportpb;

